import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [
    SharedModule,
    TranslateModule
  ]
})
export class ShowContactsModule {
}